import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { ActivatedRoute } from '@angular/router';

import { ListSearch, ListResult} from '../../entities/index';
import { ListInterface } from '../../services/crud.interface';

export class ListComponent {
  page = 1;
  terms = '';

  protected searchTermStream = new Subject<string>();
  protected pageStream = new Subject<number>();

  constructor(protected route: ActivatedRoute, protected service: ListInterface<any>) {
    this.page = parseInt(route.snapshot.queryParams.page, 10) || 1;
    this.terms = route.snapshot.queryParams.q || sessionStorage.getItem(this.getTermStorageKey()) || '';
  }

  createSource(filters?): Observable<ListResult<any>> {
    const pageSource = this.pageStream.map(pageNumber => {
      this.page = pageNumber;
      return {search: this.terms, page: pageNumber};
    });

    const searchSource = this.searchTermStream
      .debounceTime(1000)
      .distinctUntilChanged()
      .map(searchTerm => {
        sessionStorage.setItem(this.getTermStorageKey(), searchTerm);
        this.terms = searchTerm;
        this.page = 1;
        return {search: searchTerm, page: 1};
      });
      
      if(filters){
        this.page = 1;
      }
    const source = pageSource
      .merge(searchSource)
      .startWith({search: this.terms, page: this.page})
      .mergeMap((params: ListSearch) => {
        return this.service.list(params.search, params.page, undefined, filters);
      })
      .share();

    return source;
  }

  getTermStorageKey(): string {
    return 'term';
  }

  search(terms: string) {
    this.searchTermStream.next(terms);
  }

  goToPage(page: number) {
    this.pageStream.next(page);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/list.component.ts